export default "__VITE_ASSET__BuuWZa$T__"